import React from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';

import CustomLoginForm from './CustomLoginForm';
import CustomLoginFormHeader from './CustomLoginFormHeader';
import PasswordNeeded from '../../shared/PasswordNeeded';

const FormArea = styled('div')`
  padding: 30px 54px;
  display: flex;
  flex-direction: column;
  position: relative;

  @media screen and (max-width: 600px) {
    padding: 30px;
  }
`;

const FormContainer = styled('div')`
  width: 430px;
  height: auto;
  background-color: white;
  padding-bottom: 40px;

  @media screen and (max-width: 600px) {
    width: 330px;
    height: auto;
    padding-bottom: 20px;
  }
`;

const CustomLoginFormContainer = () => {
  const emailAddress = useSelector((state) => state.auth.data.emailAddress);
  const isPasswordNeeded = useSelector((state) => state.auth.data.isPasswordNeeded);

  if (isPasswordNeeded) {
    return <PasswordNeeded emailAddress={emailAddress} />;
  }

  return (
    <FormContainer>
      <CustomLoginFormHeader />
      <FormArea>
        <CustomLoginForm />
      </FormArea>
    </FormContainer>
  );
};

export default CustomLoginFormContainer;
